export default __webpack_public_path__ + "static/media/480_business06-en-web.898f92f2.png";